module.exports = "<div flex layout=\"row\">\r\n    <div ui-view layout=\"column\" flex class=\"page-container\"></div>\r\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./DeliveryCreate/UI/app/features/root/root.html
 ** module id = 319
 ** module chunks = 0
 **/